<ins class="adsbygoogle"
    [style]="adStyle"
    data-ad-client="ca-pub-2110891880748532"
    [attr.data-ad-slot]="adSlot"
    [attr.data-ad-format]="adFormat"
    [attr.data-ad-layout]="adLayout"></ins>
